import {
  ChangeDetectorRef,
  ElementRef,
  Component,
  Input,
  OnInit,
  ViewChild, AfterViewInit,
} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {HttpService} from '../../../core';
import {MatDialog} from '@angular/material/dialog';
import {CommissionSettingsComponent} from '../commission-settings/commission-settings.component';
import {ToastrService} from 'ngx-toastr';
import {environment} from '../../../../environments/environment';
import {MatMenuTrigger} from '@angular/material/menu';
import {RejectDialog} from './reject-dialog/reject-dialog';
import {ProjectDetailTabService} from 'src/app/core/services/projectDetailTab.service';
import {fromEvent} from 'rxjs';
import {debounceTime, distinctUntilChanged, map} from 'rxjs/operators';

import {ConfirmComponent} from '../../../shared/components/dialog/confirm/confirm.component';
import {MatTabGroup} from '@angular/material/tabs';

declare let window: any;

@Component({
  selector: 'app-project-cooperation',
  templateUrl: './project-cooperation.component.html',
  styleUrls: ['./project-cooperation.component.scss'],
})
export class ProjectCooperationComponent implements OnInit, AfterViewInit {
  @ViewChild('authorisedAgentSearch', {static: true})
  authorisedAgentSearch: ElementRef;

  SERVER_URL = environment.SERVER_URL;
  VERIFICATION_CODE_URL = environment.VERIFICATION_CODE_URL;
  dataSource = [];
  displayedColumns: string[] = ['agency', 'contact', 'commission', 'action'];
  projectId: any;
  @Input() project: any;

  content: any[] = [];
  pageIndex = 0;
  pageSize = 25;
  length: number;
  totalElements: number;
  pageSizeOptions: number[] = [5, 10, 25, 50, 100];
  selectedStatus = 'Authorised';
  checked = true;
  allocationList: any[] = [];
  moreAllocationList: any[] = [];
  showDelete = false;
  commissionSetting: any;
  agencyIndex = -1;

  pendingContent: any[] = [];
  pendingPageIndex = 0;
  pendingPageSize = 25;
  pendingLength: number;
  pendingTotalElements: number;
  pendingPageSizeOptions: number[] = [5, 10, 25, 50, 100];
  pendingAgencyIndex = -1;

  LogContent: any[] = [];
  logData: any;
  logTotalElements = 0;

  rate = 1;
  groupName = '1';
  total = 0.0;
  stageOne = 0.0;
  stageTwo = 0.0;
  stageThree = 0.0;

  notEqualError = false;

  hasNullElement = false;

  showBtn = false;

  applyData = {
    remark: null,
    files: null,
  };

  authorisedAgencyName: string = null;
  // authorisedAgencyStatus: string = null;

  pendingAgencyName: string = null;

  selectAgency: any = null;
  authorisedAgencyStatus = 'All';
  selectList: any[] = ['All', 'Active', 'Suspend', 'Removed'];

  @ViewChild('menuTrigger') menuTrigger: MatMenuTrigger;
  @ViewChild(MatTabGroup) tabGroup!: MatTabGroup;


  constructor(
    private route: ActivatedRoute,
    private httpService: HttpService,
    private dialog: MatDialog,
    private toastrService: ToastrService,
    private cdr: ChangeDetectorRef,
    public tabService: ProjectDetailTabService
  ) {
  }

  ngOnInit(): void {
    console.log('---project----', this.project.name);
    window.sa_event('project_agencies_click', {
      project_name: this.project.name,
    });
    // if (this.project) {
    //     this.projectId = this.project.id;
    //     this.getData();
    // } else {
    //     this.projectId = this.route.snapshot.paramMap.get('id');
    //     this.httpService.getProjectDetailByProjectId(this.projectId).subscribe((res: any) => {
    //         console.log(res);
    //         this.project = res.data;
    //         this.getData();
    //     });
    // }

    // 获取Agency标签页
    this.searchAuthorisedAgencyList();
    this.searchPendingAgencyList();
    // this.getLogData()
    this.httpService
      .pagedListProjectApplicationLogs(this.project.id, {
        page: 0,
        pageSize: 25,
      })
      .toPromise()
      .then((res: any) => {
        this.setLogData(res);
      });
    if (this.authorisedAgentSearch) {
      fromEvent(this.authorisedAgentSearch.nativeElement, 'keyup')
        .pipe(
          map((event: any) => {
            console.log(
              'this.authorisedAgentSearch.nativeElement',
              this.authorisedAgentSearch.nativeElement
            );

            return event.target.value;
          }),
          debounceTime(500),
          distinctUntilChanged()
        )
        .subscribe((r) => {
          console.log(r);
        });
    }
  }

  ngAfterViewInit() {
    const tabIndex = this.route.snapshot.paramMap.get('tabIndex');
    this.tabGroup.selectedIndex = +tabIndex - 6;
    // if (tabToOpen) {
    // switch (tabToOpen) {
    //   case 'pending':
    //     this.tabGroup.selectedIndex = 1;
    //     break;
    // }
    // }
  }

  setValue() {
    const total = this.total;
    if (total > 0) {
      if (this.groupName === '1') {
        this.stageOne = total;
      }
      if (this.groupName === '2') {
        this.stageOne = Number((total * 0.5).toFixed(2));
        this.stageTwo = Number(total - this.stageOne);
      }
      if (this.groupName === '3') {
        this.stageOne = Number((total * 0.3333).toFixed(2));
        this.stageTwo = Number((total * 0.3333).toFixed(2));
        this.stageThree = Number(total - this.stageOne - this.stageTwo);
      }
    }
  }

  searchAuthorisedAgencyList() {
    this.httpService
      .getProjectAgency(this.project.id, {
        page: this.pageIndex,
        pageSize: this.pageSize || 25,
        name: this.authorisedAgencyName,
        status:
          this.authorisedAgencyStatus == 'All'
            ? null
            : this.authorisedAgencyStatus,
      })
      .toPromise()
      .then((res: any) => {
        this.setData(res);
      });
  }

  changeStatus(event: any) {
    if (event.value) {
      this.authorisedAgencyStatus = event.value;
      this.searchAuthorisedAgencyList();
    }
  }

  getSalesByPage(pageSize, e) {
    this.httpService
      .getProjectAgency(this.project.id, {
        page: e.pageIndex,
        pageSize: e.pageSize,
        name: this.authorisedAgencyName,
        status:
          this.authorisedAgencyStatus == 'all'
            ? null
            : this.authorisedAgencyStatus,
      })
      .toPromise()
      .then((res: any) => {
        console.log(res.data, 'res.data.content');
        this.setData(res);
      });
  }

  setData(res) {
    this.content = res.data.content;
    this.length = res.data.totalElements;
    this.pageIndex = res.data.number;
    // this.pageSize = res.data.size;
    this.totalElements = res.data.totalElements;
    this.content.forEach((item) => {
      item.showBtn = false;
    });
  }

  searchPendingAgencyList() {
    console.log('searchPendingAgencyList', this.pendingPageSize);
    this.httpService
      .pendingProjectAgencies(this.project.id, {
        page: this.pendingPageIndex,
        pageSize: this.pendingPageSize,
        name: this.pendingAgencyName,
      })
      .toPromise()
      .then((res: any) => {
        this.setPendingData(res);
      });
  }

  getPendingSalesByPage(pageSize, e) {
    this.httpService
      .pendingProjectAgencies(this.project.id, {
        page: e.pageIndex,
        pageSize: e.pageSize,
        name: this.pendingAgencyName,
      })
      .toPromise()
      .then((res: any) => {
        this.setPendingData(res);
      });
  }

  setPendingData(res) {
    console.log('setPendingData', res.data);
    this.pendingContent = res.data.content;
    this.pendingLength = res.data.totalElements;
    this.pendingPageIndex = res.data.number;
    // maomao  这个我注释了 不知道有啥用 有的话接口的pageSize = 0会报错
    // this.pendingPageSize = res.data.size;
    this.pendingTotalElements = res.data.totalElements;
  }

  setLogData(res) {
    this.LogContent = res.data.content;
    this.logData = res;
    this.logTotalElements = res.data.totalElements;
  }

  selectStatus(status) {
    this.selectedStatus = status;
  }

  updateStatus(type, id, companyName) {
    if (type == 'remove') {
      const dialogRef = this.dialog.open(ConfirmComponent, {
        data: {
          description:
            'Are you confirm delete ' +
            companyName +
            ' from Authorised Agencies?',
          confirmText: 'Yes',
          cancelText: 'Cancel',
        },
      });
      dialogRef.afterClosed().subscribe((res) => {
        if (res.code === 1) {
          const item = {
            status: type,
          };
          this.httpService
            .changeProjectAgencyStatus(item, this.project.id, id)
            .toPromise()
            .then((res: any) => {
              this.ngOnInit();
            });
        }
      });
    } else {
      const item = {
        status: type,
      };
      this.httpService
        .changeProjectAgencyStatus(item, this.project.id, id)
        .toPromise()
        .then((res: any) => {
          this.ngOnInit();
          // showbtn = false
        });
    }
  }

  openAgency(item, i) {
    this.selectAgency = item;
    if (i == this.agencyIndex) {
      this.agencyIndex = -1;
    } else {
      this.agencyIndex = i;
    }
    this.httpService
      .getAgencyAllocation(this.project.id, item.id)
      .toPromise()
      .then((res: any) => {
        this.setAllocationList(res.data);
      });
    this.httpService
      .getProjectCommissionSetting(this.project.id, item.id)
      .toPromise()
      .then((res: any) => {
        this.commissionSetting = res.data;
      });
  }

  setAllocationList(data) {
    if (data.length > 9) {
      this.allocationList = data.splice(0, 9);
      this.moreAllocationList = data;
    } else {
      this.allocationList = data;
    }
  }

  moreAllocation(type: boolean) {
    const data = this.allocationList;
    if (type) {
      this.moreAllocationList.forEach((e) => {
        this.allocationList.push(e);
      });
    } else {
      this.allocationList = data.splice(0, 9);
      this.moreAllocationList = data;
    }
  }

  openPendingAgency(item, i) {
    if (i == this.pendingAgencyIndex) {
      this.pendingAgencyIndex = -1;
    } else {
      this.pendingAgencyIndex = i;
    }

    this.httpService
      .getApplyDetail(item.applyId)
      .toPromise()
      .then((res: any) => {
        this.applyData = res.data;
      });
  }

  deleteAllocation(item, propertyId, i) {
    this.httpService
      .deleteAgencyAllocation(item.id, propertyId)
      .toPromise()
      .then((res: any) => {
        if (res.code == 1) {
          item.propertyNumber -= 1;
          this.httpService
            .getAgencyAllocation(this.project.id, item.id)
            .toPromise()
            .then((res: any) => {
              this.setAllocationList(res.data);
            });
        }
      });
  }

  eoiChange(event, item) {
    // event.stopPropagation();
    this.httpService
      .changeProjectAgencyEOIState(this.project.id, item.id, {
        enableEoi: event.checked,
      })
      .toPromise()
      .then((res: any) => {
        this.ngOnInit();
      });
  }

  approve(agencyName?: string) {
    this.notEqualError = false;
    this.hasNullElement = false;
    if (!this.total) {
      document.getElementById('total').style.border = '1px solid red';
    } else {
      document.getElementById('total').style.border = '1px solid #000';
    }
    const list = [];
    if (this.groupName == '1') {
      if (!this.stageOne) {
        this.hasNullElement = true;
        document.getElementById('stage1').style.border = '1px solid red';
      } else {
        if (this.total != this.stageOne) {
          this.notEqualError = true;
        } else {
          list.push({
            activeType: 2,
            activeValue: this.stageOne,
            step: 0,
          });
        }
        document.getElementById('stage1').style.border = '1px solid #000';
      }
    }
    if (this.groupName == '2') {
      if (!this.stageTwo) {
        this.hasNullElement = true;
        document.getElementById('stage2').style.border = '1px solid red';
      } else {
        if (this.total != this.stageOne + this.stageTwo) {
          this.notEqualError = true;
        } else {
          list.push({
            activeType: 1,
            activeValue: this.stageOne,
            step: 0,
          });
          list.push({
            activeType: 3,
            activeValue: this.stageTwo,
            step: 1,
          });
        }
        document.getElementById('stage2').style.border = '1px solid #000';
      }
    }
    if (this.groupName == '3') {
      if (!this.stageThree) {
        this.hasNullElement = true;
        document.getElementById('stage3').style.border = '1px solid red';
      } else {
        if (this.total != this.stageOne + this.stageTwo + this.stageThree) {
          this.notEqualError = true;
        } else {
          list.push({
            activeType: 1,
            activeValue: this.stageOne,
            step: 0,
          });
          list.push({
            activeType: 2,
            activeValue: this.stageTwo,
            step: 1,
          });
          list.push({
            activeType: 3,
            activeValue: this.stageThree,
            step: 2,
          });
        }
        document.getElementById('stage3').style.border = '1px solid #000';
      }
    }

    if (this.notEqualError || this.hasNullElement) {
      return;
    } else {
      const submitData = {
        total: this.total,
        totalUnit: this.rate,
        groupName: this.groupName,
        stageSettingList: list,
      };
      this.httpService
        .approveProjectApply(
          this.pendingContent[this.pendingAgencyIndex].applyId,
          submitData
        )
        .toPromise()
        .then((res: any) => {
          window.sa_event('project_agency_approve', {
            project_name: this.project.name,
            agency: agencyName,
          });
          this.ngOnInit();
        });
    }
  }

  openReject(agencyName?: string) {
    this.dialog
      .open(RejectDialog, {
        width: '400px',
        data: {
          applyId: this.pendingContent[this.pendingAgencyIndex].applyId,
          agencyName,
          projectName: this.project.name
        },
      })
      .afterClosed()
      .subscribe((r: any) => {
        this.toastrService.error('Deny authorization');
        this.ngOnInit();
      });
  }

  // getData() {
  //     this.httpService.getAgencyByProjectId(this.projectId).subscribe((r: any) => {
  //         console.log(r);
  //         this.dataSource = r.data;
  //         this.dataSource.map((item, index) => {
  //             item.commission = this.project.commissionSettings.filter(c => c.agentCompany.id === item.id)[0];
  //         });
  //         this.cdr.detectChanges();
  //     });
  // }

  openCommissionSettings(agencyId, agency) {
    this.dialog
      .open(CommissionSettingsComponent, {
        width: '80%',
        maxWidth: '800px',
        data: {
          projectId: this.project.id,
          agencyId,
          commission: agency,
        },
      })
      .afterClosed()
      .subscribe((r: any) => {
        if (r === 1) {
          this.toastrService.success('Commission settings has been set');
          this.httpService
            .getProjectCommissionSetting(this.project.id, this.selectAgency.id)
            .toPromise()
            .then((res: any) => {
              this.commissionSetting = res.data;
            });
        }
      });
  }

  previewApplyFile(file, applyInfo) {
    window.open(
      this.VERIFICATION_CODE_URL +
      'files/' +
      applyInfo.id +
      '/application/' +
      file.fileName
    );
  }

  /**
   * @author Damon Gao
   * @description Get project name and agency name for Simply Analytics
   * @param i list
   */
  eventTrack(i: any) {
    window.sa_event('project_agency_click', {
      project_name: this.project.name,
      agency: i
    });
  }
}
